import { useErrorBoundary } from 'react-error-boundary';
import { Link } from 'react-router-dom';

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div className="error-boundary">
      <div className="error-content">
        <h1>Something went wrong</h1>
        <p>We apologize for the inconvenience. Please try refreshing the page.</p>
        <div className="error-actions">
          <button onClick={resetErrorBoundary} className="btn btn-primary">
            Try again
          </button>
          <Link to="/" className="btn btn-secondary">
            Return to Home
          </Link>
        </div>
        {process.env.NODE_ENV === 'development' && (
          <details className="error-details">
            <summary>Error Details</summary>
            <pre>{error.message}</pre>
          </details>
        )}
      </div>
    </div>
  );
};

export { ErrorFallback }; 